import { useCallback, useEffect } from 'react';

import useStore from '@/state';
import setBreadcrumbIndexAction from '@/state/selectors/secondary-nav/set-breadcrumb-index';

const useBreadcrumbs = () => {
	const setBreadcrumbIndex = useStore(setBreadcrumbIndexAction);

	const onOutsideClick = useCallback(
		(event: MouseEvent) => {
			const clickedElement = event.target as HTMLElement;
			const isBreadcrumb = !!clickedElement?.closest(
				'.dxnav__breadcrumbs',
			);

			if (!isBreadcrumb) setBreadcrumbIndex(null);
		},
		[setBreadcrumbIndex],
	);

	useEffect(() => {
		document.addEventListener('click', onOutsideClick);

		return () => {
			document.removeEventListener('click', onOutsideClick);
		};
	}, [onOutsideClick]);
};

export default useBreadcrumbs;
